import { create } from "zustand";
import { MessageState, Message } from "./types";
import { HistoryMessage } from "src/services/api/chat";

const useMessageStore = create<MessageState>((set: any, get: any) => ({
    messages: [],
    actualContext: undefined,
    jsonContext: undefined,
    setActualContext: (newContext) => set({actualContext: newContext}),
    setJsonContext: (newContext) => set({jsonContext: newContext}),
    addMessage: (newMsg: Partial<Message>) => {
        const message: Message = {
            id: newMsg.id || `message-${Date.now()}-${Math.random()}`,
            text: newMsg.text || '',
            timestamp: newMsg.timestamp || new Date(),
            context: newMsg.context,
            answer: newMsg.answer,
            status: newMsg.status,
            jsonMessage: newMsg.jsonMessage,
            questionText: newMsg.questionText,
        };
        set({ messages : [...get().messages, message]});
    },
    setMessages: (newMessages)=> set({messages: newMessages}),
    loadHistoryMessages: (historyMessages: HistoryMessage[]) => {
        const transformedMessages: Message[] = [];
        const baseTime = Date.now() - (historyMessages.length * 2 * 60000); // Distribute messages over time
        
        historyMessages.forEach((historyItem, index) => {
            const messageIndex = index * 2;
            const questionTime = new Date(baseTime + messageIndex * 60000);
            const answerTime = new Date(baseTime + (messageIndex + 1) * 60000);
            
            // Determine context - can be string or object
            const contextString = typeof historyItem.context === 'string' 
                ? historyItem.context 
                : undefined;
            const contextObject = typeof historyItem.context === 'object' && historyItem.context !== null
                ? historyItem.context
                : undefined;
            
            // Create question message
            transformedMessages.push({
                id: `history-question-${index}-${Date.now()}`,
                text: historyItem.question,
                timestamp: questionTime,
                answer: false,
                status: 'done' as const,
                questionText: historyItem.question,
            });
            
            // Create answer message with context and mock jsonMessage structure
            const answerMessage: Message = {
                id: `history-answer-${index}-${Date.now()}`,
                text: historyItem.answer,
                timestamp: answerTime,
                answer: true,
                status: 'done' as const,
                questionText: historyItem.question,
            };
            
            // Add context if available
            if (contextString) {
                answerMessage.context = contextString;
            }
            
            // Create a mock jsonMessage structure similar to API response
            if (contextObject) {
                answerMessage.jsonMessage = {
                    natural_language_response: historyItem.answer,
                    context: contextObject,
                };
            } else {
                answerMessage.jsonMessage = {
                    natural_language_response: historyItem.answer,
                };
            }
            
            transformedMessages.push(answerMessage);
        });
        
        set({ messages: transformedMessages });
    }
}))

export { useMessageStore };
